import { useEffect, useState } from 'react';
import classes from './ClosedModal.module.css';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Modal from '../../../../components/UI/Modals/Modal';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import {
  selectCalendarAndSlots,
  updateCalendarAndSlotsState,
} from '../../../../store/slices/calendarAndSlots';

import PrimaryButtonV2 from '../../../../components/UI/Buttons/PrimaryButtonV2';
import { useTranslation } from '../../../../hooks/useTranslations';
import { enGB, es, de, fr, nl } from 'date-fns/locale';


const localeMap: Record<string, any> = {
  en: enGB,
  es: es,
  de: de,
  fr: fr,
  nl: nl,
};
 
type Props = {
  isOpen: boolean;
  onClose: () => void;
  item: any;
};

const ClosedModal: React.FC<Props> = ({ isOpen, onClose, item }) => {
  const { translations } = useTranslation();
  const dispatch = useAppDispatch();
  const [startDate, setStartDate] = useState<Date | undefined>(new Date());
  const calendarAndSlots = useAppSelector<any>(selectCalendarAndSlots);
  let calendarData: any = Array(calendarAndSlots);
  let calendarItems = [...calendarData[0].excludes];
  const lang = localStorage.getItem('lang') || 'en';

  const handleAddOrEdit = async () => {
    const formattedDate = moment(startDate).format('YYYY-MM-DD');
    const existingIndex = calendarItems.indexOf(item);
    if (existingIndex !== -1) {
      calendarItems[existingIndex] = formattedDate;
    } else {
      calendarItems.push(formattedDate);
    }

    let dataToPost = [
      {
        ...calendarData[0],
        excludes: calendarItems,
      },
    ];

    dispatch(updateCalendarAndSlotsState(dataToPost[0]));
    onClose();
  };

  useEffect(() => {
    if (item) {
      setStartDate(new Date(item));
    } else {
      setStartDate(undefined);
    }
  }, [isOpen]);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      containerPadding="20px 10px"
      width="320px"
      header={translations('new.closings').toString()}
    >
      <div className={classes.modalContainer}>
        <div className={classes.inputContainer}>
          <div className={classes.text}>{translations('day.month.year')}</div>
          <div>
            <DatePicker
              dateFormat="dd.MM.yyyy"
              selected={startDate}
              className={classes.datepicker}
              onChange={(date: Date) => setStartDate(date)}
              locale={localeMap[lang]}
              />
          </div>
          <PrimaryButtonV2
            buttonStyle={{
              width: 250,
            }}
            text={translations('add')}
            containerStyle={{ marginTop: 190 }}
            disabled={false}
            onClick={() => handleAddOrEdit()}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ClosedModal;
